import { Stack } from "@similarweb/ui-components/foundations";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import manageSignalsPageTrackingService from "app/pages/sales-intelligence/pages/manage-signals/services/tracking";

import { useAccountSignalsPageTypes } from "../../hooks/useAccountSignalsPageTypes";
import { useAreSignalsCountsLoading } from "../../hooks/useAreSignalsCountsLoading";
import { AccountSignalTypeCards } from "../AccountSignalTypeCards/AccountSignalTypeCards";
import { AllowUserCustomizationToggle } from "../AllowUserCustomizationToggle/AllowUserCustomizationToggle";

type AccountSignalsManagementSectionProps = {
    onSignalTypeClick: (signalType: SignalType) => void;
};

export const AccountSignalsManagementSection = ({ onSignalTypeClick }: AccountSignalsManagementSectionProps) => {
    const { displayTypes, viewModel, isHighLevelAccount } = useAccountSignalsPageTypes();
    const isSignalsCountLoading = useAreSignalsCountsLoading();

    const handleUserCustomizationToggleChange = (isEnabled: boolean): void => {
        manageSignalsPageTrackingService.trackCustomizationToggle(isEnabled);
    };

    return (
        <Stack
            gap="16px"
            alignItems="flex-start"
            width="100%"
            data-automation="account-signals-management-section"
        >
            <AccountSignalTypeCards
                displayTypes={displayTypes}
                signalsCountPerType={viewModel.signalsCountPerType}
                isSignalsCountLoading={isSignalsCountLoading}
                onSignalTypeClick={isHighLevelAccount ? onSignalTypeClick : undefined}
            />
            {isHighLevelAccount ? (
                <AllowUserCustomizationToggle onToggle={handleUserCustomizationToggleChange} />
            ) : null}
        </Stack>
    );
};
